import axios from 'axios'

// axios.defaults.baseURL = 'https://api.aliyin.com/api'; //配置接口地址  

// POST传参序列化 
// axios.interceptors.request.use((config) => {
     //判断是否存在token，如果存在将每个页面header都添加token
//     if (localStorage['token']) {
// 	        config.headers.common['token'] = localStorage['token']
//     }
    // return config;
// }, (error) => {
//     return Promise.reject(error);
// }); 

//   // http response 拦截器
// axios.interceptors.response.use(response => {
// 	if(response.config.headers.token){
// 		store.commit('setToken', response.config.headers.token)
// 	}
// 	return response;
// 	},
// error => {

// });
export default axios;